import React, {useState} from 'react';
import {Box, Link, Typography, useTheme} from "@mui/material";
import ChangelogDialog from "../dialog-component/changelog-dialog";

function MainFooter(props) {
    const theme=useTheme()
    const [changelogOpen, setChangelogOpen] = useState(false);

    return (
        <>
            <ChangelogDialog open={changelogOpen} onClose={() => setChangelogOpen(false)} />
            <Box sx={{display:'flex',paddingY:1,paddingX:1,background:"transparent",borderTop:"1px solid #D7DBEC",gap:2}}>
                <Typography variant={"caption"} color={"text.disabled"} flex={"1 1 fit-content"}>© Variablegrid Adaptive Power Inc.</Typography>
                <Link
                    component="button"
                    variant="caption"
                    color="text.disabled"
                    sx={{
                        textDecoration: 'none',
                        cursor: 'pointer',
                        '&:hover': { color: 'primary.main', textDecoration: 'underline' }
                    }}
                    onClick={() => setChangelogOpen(true)}
                >
                    What's New
                </Link>
                <Typography variant={"caption"} color={"text.disabled"} flex={"fit-content 0 fit-content"}>Support</Typography>
                <Typography variant={"caption"} color={"text.disabled"} flex={"fit-content 0 fit-content"}>Terms and conditions</Typography>
                <Typography variant={"caption"} color={"text.disabled"} flex={"fit-content 0 fit-content"}>Privacy Policy</Typography>
            </Box>
        </>
    );
}

export default MainFooter;